'use client';

import React from 'react';

const DefiningDiscipline = () => {
  return (
    <section id="discipline" className="py-24 lg:py-32 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-4xl md:text-5xl font-bold font-headline text-[#0A2540] mb-12 leading-tight">
            Defining AI Change Leadership
          </h2>

          <div className="bg-[#0A2540] text-white p-12 mb-12">
            <p className="text-2xl md:text-3xl font-bold leading-relaxed">
              AI Change Leadership is the discipline of enabling organisations and public institutions to lead continuous, organisation-wide change driven by AI — at the pace AI itself evolves.
            </p>
          </div>

          <div className="space-y-8 text-lg text-gray-800 font-body leading-relaxed">
            <p>
              This discipline integrates leadership alignment, governance structures, operating model adaptation, and workforce enablement into a coherent system. It is not a methodology for project delivery. It is a capability for sustained organisational evolution.
            </p>

            <div>
              <h3 className="text-2xl font-bold text-[#0A2540] mb-4">Cross-Sector Applicability</h3>
              <p>
                AI Change Leadership applies across enterprise and government contexts. It addresses the shared challenges of leading continuous transformation in environments where AI reshapes decisions, workflows, and accountability at machine speed.
              </p>
            </div>

            <div>
              <h3 className="text-2xl font-bold text-[#0A2540] mb-4">Stewardship and Accountability</h3>
              <p>
                This discipline emphasises stewardship over execution, accountability over activity, and long-term capability over short-term delivery. It recognises that AI adoption is not a project with an end date — it is an ongoing organisational responsibility.
              </p>
            </div>

            <div>
              <h3 className="text-2xl font-bold text-[#0A2540] mb-4">Government and Public Sector Relevance</h3>
              <p>
                In government and public institutions, AI Change Leadership addresses unique considerations including policy environments, public accountability, risk and ethics frameworks, and long-horizon transformation. The discipline provides a foundation for responsible, transparent, and effective AI adoption in contexts where public trust and societal impact are paramount.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DefiningDiscipline;